/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSerieUser,
    JsonSerieUserFromJSON,
    JsonSerieUserFromJSONTyped,
    JsonSerieUserToJSON,
} from './JsonSerieUser';

/**
 * 
 * @export
 * @interface ApiResultOfJsonSerieUser
 */
export interface ApiResultOfJsonSerieUser {
    /**
     * 
     * @type {JsonSerieUser}
     * @memberof ApiResultOfJsonSerieUser
     */
    data?: JsonSerieUser;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUser
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonSerieUser
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUser
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonSerieUser
     */
    result?: ApiResultOfJsonSerieUserResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonSerieUserResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonSerieUserFromJSON(json: any): ApiResultOfJsonSerieUser {
    return ApiResultOfJsonSerieUserFromJSONTyped(json, false);
}

export function ApiResultOfJsonSerieUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonSerieUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonSerieUserFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonSerieUserToJSON(value?: ApiResultOfJsonSerieUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonSerieUserToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

